/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantDto as SecurityTenantDto } from '../../models/security/tenant-dto';

export interface GetAllTenants$Params {
}

export function getAllTenants(http: HttpClient, rootUrl: string, params?: GetAllTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityTenantDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllTenants.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SecurityTenantDto>>;
    })
  );
}

getAllTenants.PATH = '/tenant';

